import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { PopupProps } from 'types/PopUpItem';
import './PopUp.scss'

const Popup: React.FC<PopupProps> = ({ title = "", body, show, setShow }) => {

  const handleClose = () => setShow(false);

  return (
    <Modal show={show} onHide={handleClose} size="lg" className="custom-popup">
      <Modal.Header>
        <Modal.Title className='bold'>{title}</Modal.Title>
        <Button variant="close" onClick={handleClose} className="custom-close-button">
          &times;
        </Button>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  );
};

export default Popup;